<template>
    <footer class="my-5 pt-5 text-muted text-center text-small">
        <p class="mb-1">&copy; {{ currentYear }} {{ website }}</p>
        <ul class="list-inline">
            <li class="list-inline-item"><a :href="privacy">Privacy</a></li>
            <li class="list-inline-item"><a :href="`mailto:${support}`">Support</a></li>
        </ul>
    </footer>
</template>

<script >
    export default {
        computed: {
            support() {
                return this.$store.getters['settings/from'].support 
            },
            website() {
                return this.$store.getters['settings/website']
            },
            privacy() {
                return this.$store.getters['settings/from'].privacy 
            },
            currentYear() {
                return new Date().getFullYear()
            }
        }
    }
</script>